import { useQuery } from '@tanstack/react-query';
import { fetchJobTypes } from '../api/jobTypesApi';

export default function useJobTypes() {
    return useQuery({
        queryKey: ['jobTypes'],
        queryFn: fetchJobTypes,
    });
}
